import { useState, useContext } from 'react'
import { useTranslation } from "react-i18next";

import { MdOutlineFavoriteBorder, MdOutlineFavorite } from "react-icons/md";

import { AppContext } from "../../../Context";
import Fetch, { Loader } from "../../../inc/Fetch"; 

export default function like({ id }) {

    const { t } = useTranslation();
    const { cartData, userData, successData } = useContext(AppContext);
    const [cart, setcart] = cartData;
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;

    if (userinfo?.userlevel < 3) {
        return false;
    }

    function addFav() {

        Fetch("task/favAdd", (d) => {
            if (d?.error) {
                setopen({
                    short:t("error",  { returnObjects: true })[d?.error],
                    error:true
                });
            } else {
                let ck = cart?.filter(r => r == id);
                if (ck?.length) {
                    setcart(p => p?.filter(r => r != id));
                } else {
                    setcart(p => [...p, id]);
                }
            }
            
        }, { id: id });

    } 

    let ck = cart?.filter(r => r == id);
    // console.log(ck);
    
    return (
        <a className={`favBox ${ck?.length && "ck"}`} onClick={addFav}>
            {ck?.length ? <MdOutlineFavorite />: <MdOutlineFavoriteBorder />}
        </a>
    )
}
